<div class="fc-bulk-search-wrapper" data-e2e-hook="bulk-search-container">
    <form [formGroup]="multiDownloadForm">
        <ng-container *ngIf="!isInMainContentDrawer">
            <h4 class="fc-bulk-search-title">{{ 'BULK_GTIN_SEARCH.TITLE' | translate }}</h4>
        </ng-container>

        <div>
            <div class="fc-bulk-search-type-wrapper">
                <div class="fc-bulk-search-type-header">
                    <strong>{{ 'BULK_GTIN_SEARCH.TYPE_SELECTOR.TITLE' | translate }}</strong>
                </div>

                <div class="fc-bulk-search-type-options" data-e2e-hook="search-type-toggle">
                    <fcp-radiobutton
                        [e2e]="'search-type-toggle-article-numbers'"
                        inputId="bulk-search-type-article-numbers"
                        name="selectedSearchType"
                        [value]="searchType.ARTICLE_NUMBERS"
                        [ngModel]="multiDownloadForm?.get('selectedSearchType')?.value"
                        [ngModelOptions]="{ standalone: true }"
                        [label]="
                            'BULK_GTIN_SEARCH.TYPE_SELECTOR.ARTICLE_NUMBER.TITLE'
                                | translate: { articleNumber: maxDownloadLimitArticleNumber }
                        "
                        (ngModelChange)="onSearchTypeRadioChange($event)"
                    ></fcp-radiobutton>
                    <fcp-radiobutton
                        [e2e]="'search-type-toggle-gtins'"
                        inputId="bulk-search-type-gtins"
                        name="selectedSearchType"
                        [value]="searchType.GTINS"
                        [ngModel]="multiDownloadForm?.get('selectedSearchType')?.value"
                        [ngModelOptions]="{ standalone: true }"
                        [label]="
                            'BULK_GTIN_SEARCH.TYPE_SELECTOR.GTIN.TITLE' | translate: { gtin: maxDownloadLimitGtin }
                        "
                        (ngModelChange)="onSearchTypeRadioChange($event)"
                    ></fcp-radiobutton>
                </div>
            </div>

            <div class="fc-bulk-search-textarea-wrapper">
                <p class="fc-bulk-search-textarea-header fcp-text-body-s">
                    {{ 'BULK_GTIN_SEARCH.PRODUCT_CODE_INPUT.TITLE' | translate }}
                </p>

                <div class="fc-bulk-search-textarea">
                    <textarea
                        #input
                        data-e2e-hook="bulk-search-textarea"
                        placeholder="{{ 'BULK_GTIN_SEARCH.INPUT_PLACEHOLDER' | translate }}"
                    ></textarea>
                </div>

                <ng-container *ngIf="itemsLimitValidation | async as validation">
                    <div *ngIf="validation.showNotification">
                        <fcp-alert *ngIf="isGtinsSearch | async" [type]="alertType.Warning">
                            {{
                                'BULK_GTIN_SEARCH.EAN.LIMIT_REACHED.WARNING'
                                    | translate: { gtinLimit: maxDownloadLimitGtin }
                            }}
                            "{{ validation.lastItem }}"
                        </fcp-alert>
                        <fcp-alert *ngIf="isArticleNumbersSearch | async" [type]="alertType.Warning">
                            {{
                                'BULK_GTIN_SEARCH.ARTICLE_NUMBERS_LIMIT_REACHED.WARNING'
                                    | translate: { articleNumberLimit: maxDownloadLimitArticleNumber }
                            }}
                            "{{ validation.lastItem }}"
                        </fcp-alert>
                    </div>
                </ng-container>

                <ng-container *ngIf="itemsFormatValidation | async as validation">
                    <div *ngIf="validation.showNotificationSomeInvalid">
                        <fcp-alert [type]="alertType.Warning">
                            {{
                                'BULK_GTIN_SEARCH.SOME_GTIN_INVALID'
                                    | translate
                                        : {
                                              invalidGtinsAmount: validation.invalidGtinsAmount,
                                              totalGtinsAmount: validation.totalGtinsAmount
                                          }
                            }}
                            {{ validation.invalidGtinsSample }}
                        </fcp-alert>
                    </div>

                    <div *ngIf="validation.showNotificationAllInvalid" class="fc-bulk-search-warning-messages">
                        <fcp-alert [type]="alertType.Error">{{
                            'BULK_GTIN_SEARCH.ALL_GTINS_INVALID' | translate
                        }}</fcp-alert>
                    </div>
                </ng-container>

                <ng-container *ngIf="isInMainContentDrawer" [ngTemplateOutlet]="downloadErrors"></ng-container>
            </div>
        </div>
    </form>

    <div class="fc-bulk-search-download-options-wrapper">
        <div class="fc-bulk-search-download-header">
            <strong>{{ 'BULK_GTIN_SEARCH.DOWNLOAD_TYPE.TITLE' | translate }}</strong>
        </div>

        <div class="fc-bulk-search-download-controls">
            <div
                class="fc-bulk-search-download-options"
                [class.fc-bulk-search-download-options--drawer]="isInMainContentDrawer"
            >
                <div class="fc-bulk-search-download-column">
                    <div class="fc-bulk-search-download-toggle">
                        <fcp-toggle-switch
                            [e2e]="'bulk-download-option-images'"
                            [ngModel]="selectedImageDownloadType"
                            (onChange)="onDownloadTypeSelected($event.checked, downloadEventType.DOWNLOAD_IMAGES)"
                        ></fcp-toggle-switch>
                        <span class="fc-bulk-search-download-toggle-label fcp-text-body-m">{{
                            'BULK_GTIN_SEARCH.DOWNLOAD_TYPE.IMAGES.TITLE' | translate
                        }}</span>
                    </div>

                    <div class="fc-bulk-search-download-multi-choice" *ngIf="selectedImageDownloadType">
                        <div
                            *ngFor="let resolutionOption of resolutionOptionsTranslated"
                            class="fc-bulk-search-download-multi-choice-item"
                        >
                            <fcp-radiobutton
                                [inputId]="'bulk-search-resolution-' + resolutionOption.value"
                                [e2e]="'bulk-download-select-resolution-' + resolutionOption.value"
                                name="selectedResolution"
                                [value]="resolutionOption.value"
                                [ngModel]="multiDownloadForm?.get('selectedResolution')?.value"
                                [ngModelOptions]="{ standalone: true }"
                                [disabled]="!selectedImageDownloadType"
                                [label]="resolutionOption.label"
                                (ngModelChange)="onResolutionRadioChange($event)"
                            ></fcp-radiobutton>
                        </div>
                    </div>
                </div>

                <div class="fc-bulk-search-download-column" *ngIf="videoDownloadEnabled()">
                    <div class="fc-bulk-search-download-toggle">
                        <fcp-toggle-switch
                            [e2e]="'bulk-download-option-videos'"
                            [ngModel]="selectedVideoDownloadType"
                            (onChange)="onDownloadTypeSelected($event.checked, downloadEventType.DOWNLOAD_VIDEOS)"
                        ></fcp-toggle-switch>
                        <span class="fc-bulk-search-download-toggle-label fcp-text-body-m">{{
                            'DOWNLOAD_CONTENT_MODAL.TOGGLE_VIDEOS' | translate
                        }}</span>
                    </div>
                </div>

                <div class="fc-bulk-search-download-column">
                    <div class="fc-bulk-search-download-toggle">
                        <fcp-toggle-switch
                            [e2e]="'bulk-download-option-csv'"
                            [ngModel]="selectedCsvDownloadType"
                            (onChange)="onDownloadTypeSelected($event.checked, downloadEventType.DOWNLOAD_CSV)"
                        ></fcp-toggle-switch>
                        <span class="fc-bulk-search-download-toggle-label fcp-text-body-m">{{
                            'DOWNLOAD_CONTENT_MODAL.TOGGLE_DATA_ATTRIBUTES' | translate
                        }}</span>
                    </div>

                    <div class="fc-bulk-search-download-multi-choice" *ngIf="selectedCsvDownloadType">
                        <div
                            *ngFor="let csvLanguageOption of csvLanguageOptionsTranslated"
                            class="fc-bulk-search-download-multi-choice-item"
                        >
                            <fcp-radiobutton
                                [inputId]="'bulk-search-csv-' + csvLanguageOption.value"
                                [e2e]="'bulk-download-select-csv-language-' + csvLanguageOption.value"
                                name="selectedCsvLanguage"
                                [value]="csvLanguageOption.value"
                                [ngModel]="multiDownloadForm?.get('selectedCsvLanguage')?.value"
                                [ngModelOptions]="{ standalone: true }"
                                [disabled]="!selectedCsvDownloadType"
                                [label]="csvLanguageOption.label"
                                [additionalLabel]="csvLanguageOption.hint | translate"
                                (ngModelChange)="onCsvLanguageRadioChange($event)"
                            ></fcp-radiobutton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="!isInMainContentDrawer" [ngTemplateOutlet]="downloadErrors"></ng-container>

    <div class="fc-bulk-search-download-buttons" *ngIf="!isInMainContentDrawer">
        <button
            fcp-button
            color="prominent"
            [disabled]="!(isInputValid | async) || isDownloadDisabled"
            (click)="onClickDownload()"
            [attr.data-e2e-hook]="'bulk-download-button'"
        >
            <fcp-icon [icon]="['fal', 'download']"></fcp-icon>
            {{ 'ACTIONS.DOWNLOAD' | translate }}
        </button>
    </div>
</div>

<div *ngIf="isInMainContentDrawer" class="fc-bulk-search-footer">
    <button
        fcp-outlined-button
        class="fc-bulk-search-cancel-button-drawer"
        [size]="buttonSize.Large"
        [attr.data-e2e-hook]="'bulk-download-cancel-button-drawer'"
        (click)="onClickCancel()"
    >
        {{ 'TEXT_CANCEL' | translate }}
    </button>
    <button
        fcp-button
        class="fc-bulk-search-download-button-drawer"
        color="prominent"
        [size]="buttonSize.Large"
        [disabled]="!(isInputValid | async) || isDownloadDisabled"
        [attr.data-e2e-hook]="'bulk-download-button-drawer'"
        (click)="onClickDownload()"
    >
        <fcp-icon [icon]="['fal', 'download']"></fcp-icon>
        {{ 'ACTIONS.DOWNLOAD' | translate }}
    </button>
</div>

<ng-template #downloadErrors>
    <div
        *ngIf="
            (missingImagesInDownload | async) ||
            (selectedCsvDownloadType && (missingProductDataInDownload | async)) ||
            (userHasBasicPlan && (hasImagesRestrictions | async))
        "
        class="fc-bulk-search-download-messages"
    >
        <ng-container *ngIf="missingImagesInDownload | async as missingImagesInDownload">
            <fcp-alert [type]="alertType.Error">
                <span *ngIf="isGtinsSearch | async">
                    {{
                        'BULK_GTIN_SEARCH.GTINS.MISSING_IMAGE_RESULT'
                            | translate
                                : {
                                      missingNumber: missingImagesInDownload.notFound,
                                      missingImagesNumber:
                                          missingImagesInDownload.notFoundImages + missingImagesInDownload.notFound,
                                      totalNumber: missingImagesInDownload.requested
                                  }
                    }}
                </span>
                <span *ngIf="isArticleNumbersSearch | async">
                    {{
                        'BULK_GTIN_SEARCH.ARTICLE_NUMBERS.MISSING_IMAGE_RESULT'
                            | translate
                                : {
                                      missingNumber: missingImagesInDownload.notFound,
                                      missingImagesNumber:
                                          missingImagesInDownload.notFoundImages + missingImagesInDownload.notFound,
                                      totalNumber: missingImagesInDownload.requested
                                  }
                    }}
                </span>
            </fcp-alert>
        </ng-container>
        <ng-container *ngIf="selectedCsvDownloadType && missingProductDataInDownload | async">
            <fcp-alert [type]="alertType.Error">
                {{ 'BULK_GTIN_SEARCH.CHECK_CSV' | translate }}
            </fcp-alert>
        </ng-container>

        <ng-container *ngIf="userHasBasicPlan && (hasImagesRestrictions | async)">
            <fcp-alert [type]="alertType.Error">
                {{ 'BULK_GTIN_SEARCH.IMAGES_RESTRICTIONS' | translate: (imagesRestrictions | async) }}
            </fcp-alert>
        </ng-container>
    </div>
</ng-template>
